var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 8,
    viewBox: "0 0 33 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#F0A028"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.293,
    cy: 4,
    r: 4,
    fill: "#378ADD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5859,
    cy: 4,
    r: 4,
    fill: "#14904A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse3);
export default __webpack_public_path__ + "static/media/ellipse3.3de1dd543b8a1d91fdf38dd167118ac7.svg";
export { ForwardRef as ReactComponent };